// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class DocumentUploadModel {
  dataStream: string;
  documentType: string;
  opportunityKey: string;
  modifiedByUser: string;
  name: string;
  title: string;
  comments: string;
  sapJobNumber: string;
  opportunityName: string;
}
